import React from 'react';
import { Chart } from 'react-chartjs-2';
import SelectBox from '../../components/SelectBox';
import classes from './dashboard.module.css';
import NoChartData from './NoChartData';

const options = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      beginAtZero: true,
      display: true,
      grid: {
        drawOnChartArea: false,
      },
      ticks: {
        font: {
          size: 8,
        },
      },
    },
    y: {
      display: false,
      grid: {
        drawOnChartArea: false,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
      position: 'top',
    },
    title: {
      display: false,
      text: 'Top Source Countries',
    },
    datalabels: {
      display: false,
    },
  },
};

function createGradient(ctx, area) {
  const colorStart = 'rgba(192, 20, 18, 1)';
  const colorMid = 'rgba(2192, 20, 18, 0.9)';
  const colorEnd = 'rgba(255, 122, 0, 1';

  const gradient = ctx.createLinearGradient(0, area.top, 0, area.bottom);

  gradient.addColorStop(0, colorStart);
  gradient.addColorStop(0.5, colorMid);
  gradient.addColorStop(1, colorEnd);

  return gradient;
}

const SourceCountries = (props) => {
  const { 
    topValueSourceCountries, 
    setTopValueSourceCountries, 
    dataSource,
    loading = false
  } = props.data;

  const chartRef = React.useRef(null);
  const [chartData, setChartData] = React.useState({
    datasets: [],
  });
  const [data, setData] = React.useState({});

  // const labels = [
  //   'United States',
  //   'India',
  //   'Canada',
  //   'Brazil',
  //   'France',
  //   'Germany',
  //   'Czech Republic',
  //   'Japan',
  //   'Singapore',
  //   'China',
  // ];

  // const data = {
  //   labels,
  //   datasets: [
  //     {
  //       type: 'bar',
  //       fill: true,
  //       label: 'Sources',
  //       data: [700, 650, 500, 490, 453, 421, 368, 346, 310, 200],
  //       borderColor: 'rgba(230, 111, 0, 1)',
  //       borderWidth: 0,
  //       borderRadius: 8,
  //     },
  //   ],
  // };

  React.useEffect(() => {
    const labels = [];
    const data = [];
    if (dataSource && dataSource.length > 0) {
      dataSource.forEach((d) => {
        if (d.length > 0) {
          labels.push(d[0]);
          data.push(d[1]);
        }
      });
    }
    setData({
      labels,
      datasets: [
        {
          type: 'bar',
          fill: true,
          label: 'Sources',
          data,
          borderColor: 'rgba(230, 111, 0, 1)',
          borderWidth: 0,
          borderRadius: 8,
        },
      ],
    });
  }, [dataSource]);

  React.useEffect(() => {
    const chart = chartRef.current;

    if (!chart || Object.keys(data).length === 0) {
      return;
    }

    const chartData = {
      ...data,
      datasets: data.datasets.map((dataset) => ({
        ...dataset,
        backgroundColor: createGradient(chart.ctx, chart.chartArea),
      })),
    };

    setChartData(chartData);
  }, [data]);

  return (
    <div className={classes.source_countries}>
      <div className={classes.card_heading}>
        <div className={classes.card_heading_left}>
          <h3 className={classes.card_heading_text}>
            Top {topValueSourceCountries}
            {loading && <span className={classes.loadingIndicator}> (Loading...)</span>}
          </h3>
          <p className={classes.card_heading_subtext}>Source Countries</p>
        </div>
        <SelectBox
          style={{ width: '20rem' }}
          value={topValueSourceCountries}
          onChange={(e) => setTopValueSourceCountries(e.target.value)}
          disabled={loading}
        >
          <option value={10}>Top 10 Countries</option>
          <option value={20}>Top 20 Countries</option>
          <option value={30}>Top 30 Countries</option>
        </SelectBox>
      </div>
      <div className={classes.chart_box}>
        {loading ? (
          <div className={classes.loadingOverlay}>
            <div className={classes.loadingSpinner}></div>
          </div>
        ) : dataSource && dataSource.length > 0 ? (
          <Chart ref={chartRef} type='bar' data={chartData} options={options} />
        ) : (
          <NoChartData />
        )}
      </div>
    </div>
  );
};

export default SourceCountries;
